import {useCurrentHost} from '#imports';
import {computed} from 'vue';
import {useFeatureFlagsStore} from '../stores/feature-flags.store';

export function useGlobalMatching() {
    const {features} = useFeatureFlagsStore();
    const {getCurrentHost} = useCurrentHost();

    const isBrowsingGlobalMatching = computed(
        () =>
            features['keyword-search-global-matching'] &&
            (features['keyword-search-global-matching-for-localized-clients'] ||
                features['keyword-search-global-matching-for-defined-localized-countries'] ||
                isMaltDotCom.value),
    );

    const isMaltDotCom = computed(
        () => getCurrentHost() === 'dev.malt.com' || getCurrentHost() === 'www.integration.malt.com' || getCurrentHost() === 'www.malt.com',
    );

    return {
        isBrowsingGlobalMatching,
        isMaltDotCom,
    };
}
